import React from "react";

const DashboardCard = ({ title, value, classes = "" }) => (
  <div className="col">
    <div className="dashboard-card d-flex flex-column justify-content-center p-3 text-center h-100">
      <span className="dashboard-card-title">{title}</span>
      <span
        className={`dashboard-card-value text-ellipsis-two-lines ${classes}`}
        title={value}
      >
        {value}
      </span>
    </div>
  </div>
);

export default DashboardCard;
